<form [formGroup]="formData" novalidate (ngSubmit)="onSubmit()">
  <div class="modal-header">
    <h4 class="modal-title">{{ pageTitle }}</h4>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="activeModal.dismiss('')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body factory_admin">
    <h4 *ngIf="rfq_ids && rfq_ids.length > 0" class="selected text-center">
      {{ rfq_ids.length }} SKUs selected
    </h4>
    <div *ngIf="gettingRecords">
      <br />
      <h6 [translate]="'GENERAL.GETTING_RECORDS'"
        ><i class="fas fa-spinner fa-spin"></i> Getting records...</h6
      >
      <br />
    </div>
    <div *ngIf="!gettingRecords && factoryAdmins.length == 0">
      <br />
      <h6 class="text-warning"> No staff member assigned under this account. </h6>
      <br />
    </div>

    <div formArrayName="factory_admin">
      <ul>
        <li
          *ngFor="
            let fa of formData['controls'].factory_admin['controls'];
            let idx = index
          "
          class="text-capitalize"
        >
          <mat-checkbox color="primary" [formControlName]="idx">
            {{ factoryAdmins[idx].firstname }} {{ factoryAdmins[idx].lastname }}
          </mat-checkbox>
        </li>
      </ul>
    </div>
  </div>
  <div class="modal-footer">
    <button
      type="button"
      (click)="onSubmit(true)"
      *ngIf="authService.loginUser.is_admin"
      [ngClass]="{
        'kt-spinner kt-spinner--right kt-spinner--md kt-spinner--light': loading,
      }"
      [disabled]="loading"
      class="btn btn-primary btn-elevate"
    >
      <i class="fas fa-save"></i> Assign all SKUs
    </button>

    <button
      type="button"
      class="btn btn-danger"
      (click)="activeModal.dismiss('')"
      [translate]="'BUTTONS.CLOSE'"
    >
      <i class="fas fa-times"></i> Close
    </button>

    <button
      type="button"
      (click)="onSubmit()"
      [ngClass]="{
        'kt-spinner kt-spinner--right kt-spinner--md kt-spinner--light': loading,
      }"
      [disabled]="loading"
      id="kt_submit"
      class="btn btn-success btn-elevate"
      [translate]="'BUTTONS.ASSIGN_RFQ_ADMIN'"
    >
      <i class="fas fa-save"></i> Assign SKU Factory Admin
    </button>
  </div>
</form>
